import $ from 'jquery';
import common from './common';

import CodeHighliterFactory from '../../Services/Code/highlitersFactory';
import highlitersConfig from '../../Services/Code/highlitersConfig';
import ElementsHighliter from '../../Services/Code/elementsHighliter';

const CODE_ELEMENT_SELECTOR = 'pre code[data-claire-semantic]:not([data-claire-semantic=console])';

export default function (options) {
    let { container } = options,
        $codeElements,
        elementsHighliter,
        HighliterService;

    common(options);

    $codeElements = $(CODE_ELEMENT_SELECTOR, container);
    $codeElements.parent()
        .addClass('richContainer__blockCode');

    HighliterService = CodeHighliterFactory.create(highlitersConfig.HIGHLITER_ACE);
    elementsHighliter = new ElementsHighliter(HighliterService);

    return elementsHighliter.colorizeElement($codeElements);
}
